import { ref } from 'vue';

export function useAccountLock() {
 const isLoading = ref(false);

 const toggleLock = async (user) => {
   isLoading.value = true;
   const action = user.is_locked ? 'unlock' : 'lock';

   try {
     await axios.post(`/api/users/${user.id}/${action}`);
     window.emitter.emit('alertSuccess', {
       message: `Account ${action}ed successfully`,
       alertType: 'success',
       timer: 3
     });
     return true;
   } catch (error) {
     window.emitter.emit('alertSuccess', {
       message: error.response?.data?.message || 'Operation failed',
       alertType: 'danger', 
       timer: 3
     });
     return false;
   } finally {
     isLoading.value = false;
   }
 };

 const canManageLock = (currentUser, targetUser) => {
   return {
        canLock: ['sales_reps', 'sales_admin', 'super_admin'].includes(currentUser.role.name),
        canUnlock: ['sales_reps', 'sales_admin', 'super_admin'].includes(currentUser.role.name)
   };
 };

 return {
   isLoading,
   toggleLock,
   canManageLock
 };
}